import { authorizedAxios } from "../axiosInstances";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/Accounting`;

class AccountingService {
  generateGoodByeLetter(loanNumber, dueDate, downloadOnly) {
    return authorizedAxios
      .get(
        `${API_URL}/GoodByeLetter?loanNumber=${loanNumber}&dueDate=${dueDate}&downloadOnly=${downloadOnly}`
      )
      .then((response) => {
        return response;
      });
  }

  generateEndorsementLetter(loanNumber, endorseDate, downloadOnly) {
    return authorizedAxios
      .get(
        `${API_URL}/EndorsementLetter?loanNumber=${loanNumber}&endorseDate=${endorseDate}&downloadOnly=${downloadOnly}`
      )
      .then((response) => {
        return response;
      });
  }

  generateMortgageStatement(loanNumber, dueDate, downloadOnly) {
    return authorizedAxios
      .get(
        `${API_URL}/MortgageStatement?loanNumber=${loanNumber}&dueDate=${dueDate}&downloadOnly=${downloadOnly}`
      )
      .then((response) => {
        return response;
      });
  }

  generateForm1098(loanNumber, dueDate, downloadOnly) {
    return authorizedAxios
      .get(
        `${API_URL}/Form1098?loanNumber=${loanNumber}&dueDate=${dueDate}&downloadOnly=${downloadOnly}`
      )
      .then((response) => {
        return response;
      });
  }

  generatePurchaseAdvice(loanNumber, downloadOnly, additionalAdjustment) {
    return authorizedAxios
      .post(
        `${API_URL}/PurchaseAdvice?loanNumber=${loanNumber}&downloadOnly=${downloadOnly}`,
        additionalAdjustment
      )
      .then((response) => {
        return response;
      });
  }

  generateLoanPayment(loanNumber, dueDate, downloadOnly) {
    return authorizedAxios
      .get(
        `${API_URL}/CreateNewPayment?loanNumber=${loanNumber}&dueDate=${dueDate}&downloadOnly=${downloadOnly}`
      )
      .then((response) => {
        return response;
      });
  }
}

export default new AccountingService();
